import Skeleton from '@mui/material/Skeleton';
import * as React from 'react';
import { uid } from 'react-uid';
import { Field, List, ListItem } from '../../../design-system';
import type { FieldDefinition, FormFields, FormValues } from '../../../utils/formUtils';

type Props<Values extends FormValues> = {
  fields: FormFields<Values>;
};

export function FormLoading<Values extends FormValues>({ fields }: Props<Values>) {
  const fieldsWithStringKeysType = fields as Record<string, FieldDefinition<Values>>;
  const fieldsArray = Object.values<FieldDefinition<Values>>(fieldsWithStringKeysType);

  return (
    <List>
      {fieldsArray.map((field, idx) => (
        <ListItem key={uid(field, idx)}>
          <Field label={<Skeleton width="50%" />}>
            <Skeleton width="40%" />
          </Field>
        </ListItem>
      ))}
    </List>
  );
}
